module.exports = __webpack_public_path__ + "img/health-status-bad.eaa30bc4.svg";